module.exports = __webpack_public_path__ + "img/action-back.1ae9024b.png";